import { getParsedCookie, set as setCookie } from '@helpers/cookie';

const setLastGenderCookie = () => {
    const cookieDomain = (typeof App.Config.domainName === 'undefined'
        || App.Config.domainName === null || App.Config.domainName === '')
        ? '.boozt.com'
        : `.${App.Config.domainName}`;

    let newLastGenderCookie = {
        gender: App.Config.navGender,
        ageGroup: App.Config.navGenderAgeGroup,
        modified: App.Config.serverTime
    };

    setCookie('last_gender', JSON.stringify(newLastGenderCookie), {
        expires: 168,
        path: '/',
        domain: cookieDomain
    });

    newLastGenderCookie = null;

    return App.Config.navGender;
};

export const getCookieValue = () => {
    const defaultCookieValue = JSON.stringify({
        gender: 'women'
    });
    const lastGenderCookieObj = getParsedCookie('last_gender', defaultCookieValue);

    if (typeof lastGenderCookieObj.gender !== 'undefined'
        && lastGenderCookieObj.gender !== null
        && lastGenderCookieObj.gender !== '') {
        return lastGenderCookieObj.gender;
    }

    return null;
};

export const handleSetCookie = () => {
    if (App.Config.navGender === 'unisex') {
        // do not set cookie value on unisex
        return 'women';
    }

    if (typeof App.Config.navGender === 'undefined'
        || App.Config.navGender === null
        || App.Config.navGender === ''
    ) {
        // default in case nothing is set
        App.Config.navGender = 'women';
    }

    setLastGenderCookie();

    return App.Config.navGender;
};

export const getGender = () => {
    if (typeof App.Config.navGender === 'undefined'
        || App.Config.navGender === null
        || App.Config.navGender === ''
        || App.Config.navGender === 'unisex'
    ) {
        return getCookieValue();
    }

    return handleSetCookie();
};
